import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { setActiveDomainCallLoading, setActiveDomainCall } from '../../../state/callCenter/activeDomainCall';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';


export function* fetchActiveDomainCallSaga() {
    try {
        yield put(setActiveDomainCallLoading(true));
        
        const { domain } = yield select(selectUserCredentials);

        const apiUrl = '?format=json&object=call&action=read'
        const params = {
            domain: domain,
        };
        const response = yield call(cirrusClient.get, apiUrl, { params })
        yield put(setActiveDomainCall(response.data));

    } catch (error) {
        console.error('Error fetching active calls', error)

    }

}